import { ApiGroup } from "../types/ApiTypes"

const BodyPartAPI: ApiGroup = {
    getAll: {
        title: "신체 부위 전체 조회",
        url: "/BodyPart/All",
        method: "GET",
        paramz: {},
    },
    pagedList: {
        title: "신체 부위 페이징 조회",
        url: "/BodyPart/paged",
        method: "GET",
        paramz: { PageNumber: 1, PageSize: 10 },
    },
    create: {
        title: "신체 부위 생성",
        url: "/BodyPart",
        method: "POST",
        paramz: {},
    },
    update: {
        title: "신체 부위 수정",
        url: "/BodyPart/{seqId}",
        method: "PUT",
        pathParams: ["seqId"],
        paramz: {},
    },
    delete: {
        title: "신체 부위 삭제",
        url: "/BodyPart/{seqId}",
        method: "DELETE",
        pathParams: ["seqId"],
        paramz: {},
    },
}

export default BodyPartAPI
